import React, {JSX, useState} from 'react';
import styled from 'styled-components';
import { MultiSelect, MultiSelectProps } from 'primereact/multiselect';
import Polygon from 'assets/Polygon.svg';
import PolygonActive from 'assets/PolygonActive.svg';
import {Dropdown} from "components/Analytics/dropdown/dropdown";
import {DropdownProps} from "primereact/dropdown";

export interface DropdownOption<T = string> {
    label: string;
    value: T;
}

export function BaseDropdown<T>(props: {
    multiple: true;
    value: T[];
    options: DropdownOption<T>[];
    onChange: (value: T[]) => void;
} & Omit<MultiSelectProps, 'value' | 'options' | 'onChange' | 'multiple'>): JSX.Element;

export function BaseDropdown<T>(props: {
    multiple?: false;
    value: T;
    options: DropdownOption<T>[];
    onChange: (value: T) => void;
} & Omit<DropdownProps, 'value' | 'options' | 'onChange' | 'multiple'>): JSX.Element;

export function BaseDropdown<T>({
                                    value,
                                    options,
                                    onChange,
                                    multiple,
                                    ...rest
                                }: any) {
    const [isOpen, setIsOpen] = useState(false);

    const dropdownIcon = () =>
        isOpen ? <PolygonActive /> : <Polygon />;

    if (multiple) {
        return (
            <StyledMultiSelect
                value={value}
                options={options}
                onChange={(e) => onChange(e.value)}
                dropdownIcon={dropdownIcon}
                onShow={() => setIsOpen(true)}
                onHide={() => setIsOpen(false)}
                resetFilterOnHide={true}
                filterInputAutoFocus={false}
                {...rest}
            />
        );
    }

    return (
        <StyledDropdown
            value={value}
            initialValue={value}
            options={options}
            onChange={(e) => onChange(e)}
            {...rest}
        />
    );
}

const StyledMultiSelect = styled(MultiSelect)`
    height: 30px;
    display: flex;
    align-items: center;
`;

const StyledDropdown = styled(Dropdown)`
    height: 30px;
    display: flex;
    align-items: center;
`;